export { default as LoadingBar } from './LoadingBar';
export * as Styled from './LoadingBar.styles';
